import gql from 'graphql-tag'

export const GET_CUSTOMER_LIST_BY_SEARCH = gql`
  query getCustomerCategoryListBySearch($search: String) {
    customerList(search: $search) {
      nodes {
        id
        name
        tel
        email
        address
        contactMethod
        tag
        tags
        taxId
        ordersCount
        orderedValue
        rewardValue
        customerCategoryId
        customerContactMethods {
          id
          name
          contactMethod
        }
      }
    }
  }
`
export const GET_CUSTOMER_ORDER_LIST = gql`
query ($ids: [ID!]) {
  customerList (ids: $ids) {
    nodes {
      id
      tel
      name
      rewardValue
      ordersCount
      orderedValue
      orderList {
        nodes {
          id
          invoiceNumber
          price
          transferredAt,
          paidAmount
          purchases {
            id
            name
            quantity
            price
          }
          setPurchases {
            id
            name
            quantity
          }
        }
      }
    }
  }
}

`

export const GET_CUSTOMER_NOTE = gql`
query ($ids: [ID!]) {
 customerList (ids: $ids) {
    nodes {
      id
      name
      updatedAt
      customerContactMethods {
        id
        name
        contactMethod
      }
    }
  }
}

`
export default {
  GET_CUSTOMER_LIST_BY_SEARCH,
  GET_CUSTOMER_ORDER_LIST,
  GET_CUSTOMER_NOTE
}
